// getters.js

export default {
    getRulesList(state){
        return state.rulesList
    },
    getDeviceInfo: (state) => (id) => {
        return state.devicesInfo[id] || null
    },
    getSelectedDeviceRules(state){
        return state.selectedDeviceRules
    }
};
